import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-y-4" }

import { computed } from 'vue';
import { ArticleSearchResult } from '../../types';
import transformYear from '../../utils/transformYear';


export default /*#__PURE__*/_defineComponent({
  props: {
    article: null
  },
  setup(__props: any) {

const props = __props as {
  article: ArticleSearchResult;
}



const propsOrder: (keyof ArticleSearchResult['properties'])[] = [
  'family',
  'familySubtitle',
  'size',
  'housingColor',
  'lampDescription',
  'colorCombination',
  'illuminationDistribution',
  'controlType',
  'region',
  'louvre',
];

const transformedLampDescription = computed(() => {
  return props.article.properties.lampDescription
    ? Object.entries(props.article.properties.lampDescription)
        .filter(([key, value]) => value !== null && key !== '_id' && value)
        .map(([_, value]) => value)
    : [];
});

const tranformedProperties = computed(() => {
  const orderedProps = propsOrder
    .map((key) => {
      if (key === 'lampDescription') return transformedLampDescription.value;
      if (props.article.properties[key]) return props.article.properties[key]?.replaceAll('|', '');
      return [];
    })
    .flat() as string[];

  const rest = Object.entries(props.article.properties)
    .filter(
      ([key, value]) =>
        value &&
        !propsOrder.includes(key as keyof ArticleSearchResult['properties']) &&
        key !== '_id',
    )
    .map(([_, value]) => (value as string).replaceAll('|', ''));

  return orderedProps.concat(rest);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h4", _hoisted_1, _toDisplayString(__props.article.properties.family) + " - " + _toDisplayString(__props.article.articleIdCustomer) + " - " + _toDisplayString(_unref(transformYear)(__props.article.year)), 1),
    _createElementVNode("div", null, [
      _createElementVNode("p", null, _toDisplayString(_unref(tranformedProperties).join(' | ')), 1)
    ])
  ], 64))
}
}

})